<template>
  <BaseRadarChart
    :options="chartOptions"
    :labels="labels"
    :datasets="datasets"
    :width="width"
    :height="height" />
</template>

<script>
const defaultMinDimension = 5
const defaultMaxDimension = 8
import BaseRadarChart from '@/components/charts/BaseRadarChart.vue'
export default {
  components: {
    BaseRadarChart
  },
  props: {
    width: {
      type: [String, Number],
      default: 250,
    },
    height: {
      type: [String, Number],
      default: 250,
    },
    dimension: {
      type: [String, Number],
      default: defaultMinDimension
    },
    minDimension: {
      type: [String, Number],
      default: defaultMinDimension
    },
    maxDimension: {
      type: [String, Number],
      default: defaultMaxDimension
    },
  },
  computed: {
    displayDimension() {
      const dimension = +this.dimension
      const minDimension = +this.minDimension
      const maxDimension = +this.maxDimension
      if (!dimension) {
        return minDimension
      } else if (dimension > maxDimension) {
        return maxDimension
      } else if (dimension < minDimension) {
        return minDimension
      }
      return dimension
    },
    labels() {
      // eslint-disable-next-line no-unused-vars
      return [...Array(this.displayDimension).map((_) => '')]
    },
    datasets() {
      // eslint-disable-next-line no-unused-vars
      return [{ data: [...Array(this.displayDimension).map((_) => null)] }]
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
      }
    },
    chartOptions() {
      return {
        scales: {
          r: {
            grid: {
              color: '#9D9D9D'
            },
            angleLines: {
              display: false,
            },
            min: 0,
            ticks: {
              display: false,
              stepSize: 1,
              min: 0,
              max: 1
            }
          }
        },
        plugins: {
          legend: {
            display: false,
            position: 'chartArea'
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    }
  },

}
</script>

<style>

</style>